import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SegurosWPService } from 'src/app/core/http/web/segurosWp.service';
import { environment as paramsG } from 'src/environments/environment';
@Component({
  selector: 'app-single-seguros',
  templateUrl: './single-seguros.component.html',
  styleUrls: ['./single-seguros.component.scss']
})
export class SingleSegurosComponent {
  public slug: string;
  public objectValues = Object.values;
  public dataPage: any;
  // public dataHome: any;
  public dataBanner: any;
  public urlBaseS3: any = (<any>paramsG).api.s3;
  public errors: any;
  public loadPerParts: boolean;
  public loadings: any = true;
  constructor(
    private titleService: Title,
    private _route: ActivatedRoute,
    private segWpServ: SegurosWPService
  ) {
    this._route.params.forEach((params: Params) => {
      this.slug = params ? params.slug : '';
      this.titleService.setTitle( 'Seguros | ' + this.slug );
      this.getDataSingle(this.slug);
      // this.getDataHomeSeguros();
    });
  }

  getDataSingle(slug) {
    console.log('Consultando datos de slug: ', slug);
    this.segWpServ.getDataSingle(slug).subscribe(data => {
      console.log('Data single: ', data);
      this.dataPage = data;
      this.dataBanner = this.dataPage.galeria.map(e => {
        return {imagen: e,  imagenmobile: e};
      });
      console.log('New Data single', this.dataPage);
      console.log('Data banner: ', this.dataBanner);
    }, err => {
      console.error('Error en servicio getDataSingle:', err);
    });
  }
  // getDataHomeSeguros() {
  //   this.segWpServ.getAllData().subscribe(data => {
  //     console.log('Data home --->: ', data);
  //     this.dataHome = data;
  //     // this.loadings = false;
  //   }, err => {
  //     console.error('Error | getDataAllSeguros: ', err);
  //     // this.loadPerParts = true;
  //     // this.errors = err;
  //   });
  // }
  reload() {
    this.loadings = true;
    this.getDataSingle(this.slug);
  }
}
